import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup, Validators as val } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseForm } from 'src/app/shared/product/baseForm';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { ProductStepHandlingService } from '../../../../services/product-step-handling.service';

@Component({
  selector: 'app-invoice-step-four',
  templateUrl: './invoice-step-four.component.html',
  styleUrls: ['./invoice-step-four.component.scss'],
})
export class InvoiceStepFourComponent
  extends BaseForm
  implements OnInit, AfterViewInit
{
  stepFourForm!: FormGroup;
  @Input() productObject!: any;
  constructor(
    private translate: TranslateService,
    private productStepHandling: ProductStepHandlingService,
    public formValidator: FormValidatorService
  ) {
    super();
  }

  ngOnInit(): void {
    this.stepFourForm = this.formValidator.createForm([
      {
        fieldName: 'phone',
        defaultValue: null,
        validators: [],
      },
      {
        fieldName: 'email',
        defaultValue: null,
        validators: [],
      },
      {
        fieldName: 'notifyEmail',
        defaultValue: false,
        validators: [],
      },
      {
        fieldName: 'notifyPhone',
        defaultValue: false,
        validators: [],
      },
    ]);
    this.fromControllers = this.stepFourForm;
    this.stepFourForm.markAsUntouched();
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
    this.productStepHandling.isNotifyBuyersValid.emit(
      this.stepFourForm.valid
    );
    this.stepFourForm.valueChanges.subscribe(() => {
      if (this.stepFourForm.controls['phone'].valid) {
        this.formValidator.formErrors['email']='';
      }
      if (this.stepFourForm.controls['email'].valid) {
        this.formValidator.formErrors['phone']='';
      }
      this.productStepHandling.isNotifyBuyersValid.emit(
        this.stepFourForm.valid
      );
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        phone: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
          }),
          minlength: this.translate.instant('FormValidation.MinLength', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
            value: 11,
          }),
          maxlength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
            value: 11,
          }),
          pattern: this.translate.instant(
            'FormValidation.RequiredNumber'
          ),
        },
        email: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'email',
            fieldAr: 'البريد الاكتروني',
          }),
          email: this.translate.instant('FormValidation.ValidEmail', {
            field: 'email',
            fieldAr: 'البريد الاكتروني',
          }),
        },
      };
    });
  }
  ngAfterViewInit() {
    this.initForm();
  }
  initForm(){
    if (this.productObject) {
      const notified_buyers =
        this.productObject.ProductExtraInfos.find(
          (res) => res.key == 'buyersToBeNotified'
        ) || null;
      if (notified_buyers) {
        this.stepFourForm.setValue({notifyEmail:false,notifyPhone:false,...JSON.parse(notified_buyers?.value)});
      }
    }
  }
  getEmailValidations() {
    return [val.email, val.required];
  }
  getPhoneValidations() {
    return [val.required, val.minLength(11), val.maxLength(11)];
  }
  handleValidation(target:'email'|'phone',value:boolean){
    if(target=='phone'){
      if(value){
        this.stepFourForm.controls['phone'].setValidators([
          val.required,
          val.pattern("^[0-9]*$"),
          val.minLength(11),
          val.maxLength(11)
        ]);
        this.stepFourForm.controls['phone'].updateValueAndValidity();
      }else{
        this.stepFourForm.controls['phone'].clearValidators();
        this.stepFourForm.controls['phone'].setErrors([]);
        this.stepFourForm.controls['phone'].markAsUntouched();
        this.stepFourForm.controls['phone'].setValue('');
      }
    }
    if(target=='email'){
      if(value){
        this.stepFourForm.controls['email'].setValidators([
          val.required,
          val.email,
        ]);
        this.stepFourForm.controls['email'].updateValueAndValidity();
      }else{
        this.stepFourForm.controls['email'].clearValidators();
        this.stepFourForm.controls['email'].setErrors([]);
        this.stepFourForm.controls['email'].markAsUntouched();
        this.stepFourForm.controls['email'].setValue('');
      }
    }
  }
}
